// src/services/cloudinary/config.ts
// Note: L'upload utilise un unsigned preset.
// Seuls cloudName et uploadPreset sont nécessaires côté frontend.
// Ne JAMAIS exposer apiKey ou apiSecret dans le bundle client.
export const CLOUDINARY_CONFIG = {
  cloudName: import.meta.env.VITE_CLOUDINARY_CLOUD_NAME,
  uploadPreset: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET
};
